'use client'

import { LDProvider } from 'launchdarkly-react-client-sdk'

export const LaunchDarklyProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <LDProvider
      clientSideID={process.env.NEXT_PUBLIC_LAUNCH_DARKLY_CLIENT_ID ?? ''}
      options={{
        sendEvents: true,
        diagnosticOptOut: true, // Dont send diagnostics info
      }}
    >
      {children}
    </LDProvider>
  )
}
